<template>
  <v-navigation-drawer v-model="$store.state.navBar" absolute temporary>
    <v-list class="pa-1">
      <v-list-tile>
        <img :src="require('@/assets/spice-logo.png')" alt="spice money" width="150px">
        <v-spacer></v-spacer>
        <v-btn class="my-0 mr-0 ml-2" flat large icon color="primary"></v-btn>
      </v-list-tile>
    </v-list>

    <v-divider></v-divider>

    <v-list class="pt-0">
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/" title=" Spice Money">Home</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title class="rel">
            <a href="/spice-money-about" title="About Spice Money">About Us</a>
            <v-btn icon color="darkGrey" class="absBtn" @click="mobNav=!mobNav">
              <v-icon v-if="!mobNav">arrow_drop_down</v-icon>
              <v-icon v-if="mobNav">arrow_drop_up</v-icon>
            </v-btn>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="mobNav">
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/spice-money-ourJourney" title="Our Journey">Our Journey</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- <v-list-tile v-if="mobNav">
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/spice-money-team" title="Our Teams">Management Team</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->
      <v-list-tile v-if="mobNav">
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/spice-money-products" title="Our Teams">Product & Services</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="mobNav">
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/spice-money-partner" title="Partners">Partners and Alliances</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>

      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/spice-money-career" title="Career">Career</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="https://blog.spicemoney.com/" title="Blog">Blog</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            <a href="/spice-money-contact" title="Contact Spice Money">Contact Us</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title style="height:48px;">
            <div class="social-icons">
              <a href="https://www.facebook.com/SpiceMoneyOfficial" target="_blank">
                <svg style="width:32px;height:32px" viewBox="0 0 24 24">
                  <path
                    fill="#475993"
                    d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z"
                  ></path>
                </svg>
              </a>
              <a href="https://twitter.com/SpiceMoneyIndia" target="_blank">
                <svg style="width:32px;height:32px" viewBox="0 0 24 24">
                  <path
                    fill="#76a9ea"
                    d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M17.71,9.33C18.19,8.93 18.75,8.45 19,7.92C18.59,8.13 18.1,8.26 17.56,8.33C18.06,7.97 18.47,7.5 18.68,6.86C18.16,7.14 17.63,7.38 16.97,7.5C15.42,5.63 11.71,7.15 12.37,9.95C9.76,9.79 8.17,8.61 6.85,7.16C6.1,8.38 6.75,10.23 7.64,10.74C7.18,10.71 6.83,10.57 6.5,10.41C6.54,11.95 7.39,12.69 8.58,13.09C8.22,13.16 7.82,13.18 7.44,13.12C7.81,14.19 8.58,14.86 9.9,15C9,15.76 7.34,16.29 6,16.08C7.15,16.81 8.46,17.39 10.28,17.31C14.69,17.11 17.64,13.95 17.71,9.33Z"
                  ></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/spicemoneyinsta/" target="_blank">
                <svg style="width:32px;height:32px" viewBox="0 0 24 24">
                  <path
                    fill="#c3256b"
                    d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
                  ></path>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/spicemoneybharat/" target="_blank">
                <svg style="width:32px;height:32px" viewBox="0 0 24 24">
                  <path
                    fill="#0077b7"
                    d="M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M18.5,18.5V13.2A3.26,3.26 0 0,0 15.24,9.94C14.39,9.94 13.4,10.46 12.92,11.24V10.13H10.13V18.5H12.92V13.57C12.92,12.8 13.54,12.17 14.31,12.17A1.4,1.4 0 0,1 15.71,13.57V18.5H18.5M6.88,8.56A1.68,1.68 0 0,0 8.56,6.88C8.56,5.95 7.81,5.19 6.88,5.19A1.69,1.69 0 0,0 5.19,6.88C5.19,7.81 5.95,8.56 6.88,8.56M8.27,18.5V10.13H5.5V18.5H8.27Z"
                  ></path>
                </svg>
              </a>
              <a href="https://www.youtube.com/channel/UCoYrao7bUqM8v4nI6iUk_Xw" target="_blank">
                <svg style="width:34px;height:34px" viewBox="0 0 24 24">
                  <path
                    fill="#f00"
                    d="M2.5,4.5H21.5C22.34,4.5 23,5.15 23,6V17.5C23,18.35 22.34,19 21.5,19H2.5C1.65,19 1,18.35 1,17.5V6C1,5.15 1.65,4.5 2.5,4.5M9.71,8.5V15L15.42,11.7L9.71,8.5M17.25,21H6.65C6.35,21 6.15,20.8 6.15,20.5C6.15,20.2 6.35,20 6.65,20H17.35C17.65,20 17.85,20.2 17.85,20.5C17.85,20.8 17.55,21 17.25,21Z"
                  ></path>
                </svg>
              </a>
            </div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- <v-divider></v-divider>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            <a @click="$router.push({name:'innerpage.joinNow'})" title="Join Now">Join Now</a>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>-->
    </v-list>
  </v-navigation-drawer>
</template>

<style scoped>
.page-tab {
  text-decoration: none;
  color: #343434;
  font-size: 14px;
  position: relative;
  width: 100%;
  display: inline-block;
}
.router-link-exact-active {
  color: #ff4081;
}
.router-link-exact-active::after {
  position: absolute;
  border-bottom: 7px solid transparent;
  border-top: 7px solid transparent;
  border-right: 7px solid #ff4081;
  height: 0;
  width: 0;
  right: 0px;
  top: 4px;
  content: "";
  overflow: hidden;
}
.v-list__tile {
  padding-right: 0px !important;
}
.profile-info {
  padding: 15px;
  -moz-box-shadow: inset 0px 0px 10px rgba(68, 68, 68, 0.1);
  -webkit-box-shadow: inset 0px 0px 10px rgba(68, 68, 68, 0.1);
  box-shadow: inset 0px 0px 10px rgba(68, 68, 68, 0.1);

  background: #f2f2f2;
}
.profile-info i {
  vertical-align: middle;
  color: #4385f3;
}
.profile-info .v-list__tile__title {
  padding: 5px 0;
  height: inherit;
  line-height: inherit;
  color: #4385f3;
}
a {
  text-decoration: none;
}
.rel {
  position: relative;
}
.absBtn,
.absBtn:hover {
  position: absolute;
  right: 0;
  top: -6px;
  margin: 0;
}
.social-icons {
  display: flex;
  flex-grow: 1;
  margin-top: 10px;
  align-items: center;
}
.social-icons a {
  display: inline-flex;
  margin: 0 5px;
}
.social-icons a:first-child {
  margin-left: 0;
}
</style>

<script>
import MobileNavigation from "./MobileNavigation.ts";
export default MobileNavigation;
</script>